export default __webpack_public_path__ + "static/media/question-circle-fill.70273e65.svg";